module.exports = __webpack_public_path__ + "img/about-icon-4.9b2a09ee.png";